import {allLookIds, dailyMakeupLookIds, occasionLookIds, skillLevelLookIds, timeOfDayLookIds, vibeLookIds} from './looksData'

export const lookIdsForAnswers = answers => {
  const {level, vibes, occasion, daily, timeOfDay} = answers

  const lookShortlist = [
    allLookIds,
    ...(level ? [skillLevelLookIds[level]] : []),
    ...(vibes ? vibes.map(it => vibeLookIds[it]) : []),
    ...(occasion ? occasion.map(it => occasionLookIds[it]) : []),
    ...(daily ? [dailyMakeupLookIds[daily]] : []),
    ...(timeOfDay ? [timeOfDayLookIds[timeOfDay]] : []),
  ].reduce((acc, it) => {
    const smaller = acc.intersection(it)
    return smaller.size >= 3 ? smaller : acc
  })

  return Array.from(lookShortlist.values())
}

const testAllIntersections = () => {
  const minLooksForLogging = 0
  let notEnoughCount = 0
  let comboCount = 0
  Object.keys(skillLevelLookIds).forEach(lIt => {
    const level = undefined // [lIt] // 432
    Object.keys(vibeLookIds).forEach(vIt => {
      const vibes = [vIt]
      Object.keys(occasionLookIds).forEach(oIt => {
        const occasion = [oIt]
        Object.keys(dailyMakeupLookIds).forEach(dIt => {
          const daily = undefined // [dIt] // 360
          Object.keys(timeOfDayLookIds).forEach(tIt => {
            const timeOfDay = undefined // [tIt] // 228

            const looks = lookIdsForAnswers({level, vibes, occasion, daily, timeOfDay})
            if (looks.length < minLooksForLogging) {
              const countWord = looks.length < 3
                ? 'Not enough'
                : looks.length === 3 ? 'Just enough' : 'Many'
              console.log(
                `${countWord} (${looks.length}) looks found for:`,
                {levels: lIt, vibes: vIt, occasion: oIt, looks, daily: dIt, timeOfDay: tIt}
              )
            }
            if (looks.length < 3) {
              ++notEnoughCount
            }
            ++comboCount
          })
        })
      })
    })
  })
  console.log('Combinations with too few looks:', notEnoughCount) // 741
  console.log('Total combinations:', comboCount) // 900
}
// testAllIntersections()
// console.log({vibeLookIds, occasionLookIds})
